import React from "react"
import PageBody from "../../../components/PageBody"
import ProductFileUpload from "../../../components/ProductFileUpload"

const ProductImages = (props: any) => {
    const { imgs, setImgs, validation } = props

    return (
        <PageBody>
            <div className="nutri-title mb-3"><span className="text-danger mr-2">*</span>Hình ảnh sản phẩm</div>
            <ProductFileUpload
                handleChangeFile={(files: any) => {
                    setImgs(files)
                }}
                fileTypes={["JPEG", "PNG", "GIF", "JPG", "jpeg", "png", "gif", "jpg", ]}
                imgs={imgs}
            />
            {validation?.imgs &&<div className="invalid-feedback d-block" >{validation?.imgs}</div>}
        </PageBody>
    )
}

export default ProductImages